import React, { useContext } from "react";
import { Skeleton } from "primereact/skeleton";
import { useNavigate } from "react-router-dom";
import { ContactProfileDetailsContext } from "../macrocomponents/ContactLayout";
import CustomToolTip from "./CustomToolTip";

function LeftPanelImage() {
  const { contactProfilePic } = useContext(ContactProfileDetailsContext);
  const navigate = useNavigate();
  const onSettingsClick = () => navigate("agent/contact/profile");
  return (
    <div className="py-4 flex justify-center items-center ">
      <div className="w-20 h-20 rounded-3xl relative">
        {contactProfilePic ? (
          <img
            src={contactProfilePic}
            className="w-full h-full rounded-3xl object-cover"
            alt="contact profile pic"
          />
        ) : (
          <Skeleton width="5rem" height="5rem" borderRadius="8px" />
        )}
        <div
          className="absolute flex justify-center items-center w-2rem h-8 rounded-full hover:cursor-pointer bg-light-secondary"
          style={{
            right: "-1rem",
            bottom: "-0.5rem",
          }}
          onClick={onSettingsClick}
        >
          <div className="relative group flex justify-center items-center">
            <i className="pi pi-cog hover:rotate-[10deg] " style={{ fontSize: "1.2rem" }} />
            <CustomToolTip text="Settings" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeftPanelImage;
